/**
 * Maps a priso type to a URL base path
 */
export const prisoBasePath = (prisoType) => {
    switch (prisoType) {
        case "NEUANLAGE_KETTARTIKEL":
            return "/privatsortiment/neuanlage"
        case "EK_AENDERUNG":
            return "/privatsortiment/ek_aenderung"
        case "SALE":
            return "/privatsortiment/sale"
        default:
            return "/privatsortiment/neuanlage"
    }
}

/**
 * Maps a priso type to a page_names locale key for the banner
 */
export const prisoBannerKey = (prisoType) => {
    switch (prisoType) {
        case "NEUANLAGE_KETTARTIKEL":
            return "priso_neuanlage"
        case "EK_AENDERUNG":
            return "priso_ek_aenderung"
        case "SALE":
            return "priso_sale"
        default:
            return "priso_neuanlage"
    }
}
